import { Link } from 'react-router-dom';

const entries = [
  {
    to: '/category/movie',
    icon: 'ri-film-line',
    title: '电影频道',
    desc: '科幻、动作、喜剧、爱情，海量院线佳片一网打尽',
    image:
      'https://readdy.ai/api/search-image?query=Cinema%20hall%20with%20warm%20amber%20house%20lights%20and%20rows%20of%20red%20seats%20leading%20toward%20a%20glowing%20screen%20deep%20charcoal%20and%20golden%20tones%20cinematic%20atmosphere%20no%20text&width=800&height=500&seq=ptv-entry-movie&orientation=landscape',
  },
  {
    to: '/category/tv',
    icon: 'ri-tv-2-line',
    title: '电视剧频道',
    desc: '古装、都市、悬疑、奇幻，热播剧集追不停',
    image:
      'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20at%20night%20with%20a%20television%20casting%20a%20soft%20warm%20glow%20over%20a%20sofa%20deep%20navy%20shadows%20and%20amber%20accents%20cinematic%20atmosphere%20no%20text&width=800&height=500&seq=ptv-entry-tv&orientation=landscape',
  },
];

export default function CategoryEntries() {
  return (
    <section className="container-page py-10">
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group relative flex h-[180px] items-center overflow-hidden rounded-lg bg-primary-950 p-6 transition-all duration-300 hover:-translate-y-1 cursor-pointer md:h-[200px]"
          >
            <img
              src={entry.image}
              alt={entry.title}
              title={`${entry.title} - 天堂影视`}
              className="absolute inset-0 h-full w-full object-top opacity-40 transition-opacity duration-500 group-hover:opacity-55"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950 via-primary-950/80 to-transparent"></div>
            <div className="relative z-10">
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className={`${entry.icon} text-2xl`}></i>
              </span>
              <h2 className="mt-4 text-xl font-bold text-background-50">{entry.title}</h2>
              <p className="mt-1 max-w-sm text-sm text-background-200/80">{entry.desc}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-accent-400">
                进入频道
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}